"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.ProductCard = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

require("antd/lib/collapse/style");

var _collapse = _interopRequireDefault(require("antd/lib/collapse"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _HeaderCard = require("../../../components/HeaderCard");

var _ProductDetail = require("../../../shop/components/ProductDetail");

var _class;

var Panel = _collapse.default.Panel;
var cardPanelStyle = {
  background: "#c9e7ff" // background: "#dbffa4",

};

var ProductCard = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(ProductCard, _Component);

  function ProductCard(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = ProductCard.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        products = _this$props.products;
    var visibleProducts = products;
    var allActiveIndexes;
    allActiveIndexes = visibleProducts.edges.map(function (edge) {
      return edge.node.id;
    });
    return _react.default.createElement(_HeaderCard.HeaderCard, {
      title: title
    }, _react.default.createElement(_collapse.default, {
      defaultActiveKey: allActiveIndexes
    }, products && products.edges.map(function (productEdge) {
      var product = productEdge.node;
      return _react.default.createElement(Panel, {
        key: product.id,
        header: _react.default.createElement("h3", null, product.name),
        style: cardPanelStyle
      }, _react.default.createElement(_ProductDetail.ProductDetail, {
        product: product
      }));
    })));
  };

  return ProductCard;
}(_react.Component)) || _class;

exports.ProductCard = ProductCard;